// gql
import REQUEST_PASSWORD_RESET from '@dr-keyword-gql/login/request-password-reset.gql'

// apollo client
import { useMutation } from '@apollo/client'

// enums
import { microServicesEnum } from '@dr-keyword-commons/enums'

// services
import { BaseService } from '@dr-keyword-services/index'

export class LoginPageService extends BaseService {
  /**
   * @description handler for request password reset mutation
   */
  static requestPasswordReset = () => {
    const { showFormattedError } = this.getBaseService()

    const [requestPasswordReset] = useMutation(REQUEST_PASSWORD_RESET, {
      context: { ms: microServicesEnum.BACKEND },
      onError: (error) => {
        const { errorCode } = this.formatGraphqlError(error)
        showFormattedError({ enum: errorCode })
      }
    })

    return { requestPasswordReset }
  }
}
